<template>
    <v-card-text class="pa-6">

        <div class="section-container">
            <div class="section-header mb-4">
                <v-icon color="primary" size="20">mdi-domain</v-icon>
                <h3 class="section-title">Informazioni Aziendali</h3>
            </div>

            <v-alert type="info" variant="tonal" class="mb-6" density="compact">
                I dati aziendali non possono essere modificati autonomamente. Per modifiche contatta l'assistenza.
            </v-alert>

            <v-row>
                <v-col cols="12" md="6">
                    <div class="info-field">
                        <div class="info-label">
                            <v-icon size="18" color="grey-darken-1">mdi-office-building</v-icon>
                            <span>Ragione Sociale</span>
                        </div>
                        <div class="info-value">{{ azienda.ragioneSociale || '-' }}</div>
                    </div>
                </v-col>

                <v-col cols="12" md="6">
                    <div class="info-field">
                        <div class="info-label">
                            <v-icon size="18" color="grey-darken-1">mdi-card-account-details</v-icon>
                            <span>Partita IVA</span>
                        </div>
                        <div class="info-value">{{ azienda.pIva || '-' }}</div>
                    </div>
                </v-col>
            </v-row>

            <v-row>
                <v-col cols="12" md="4">
                    <div class="info-field">
                        <div class="info-label">
                            <v-icon size="18" color="grey-darken-1">mdi-map-marker-outline</v-icon>
                            <span>Indirizzo</span>
                        </div>
                        <div class="info-value">{{ azienda.indirizzo || '-' }}</div>
                    </div>
                </v-col>

                <v-col cols="12" md="4">
                    <div class="info-field">
                        <div class="info-label">
                            <!-- <v-icon size="18" color="grey-darken-1">mdi-card-account-details</v-icon> -->
                            <span>Città</span>
                        </div>
                        <div class="info-value">{{ azienda.citta || '-' }}</div>
                    </div>
                </v-col>

                <v-col cols="6" md="2">
                    <div class="info-field">
                        <div class="info-label">
                            <!-- <v-icon size="18" color="grey-darken-1">mdi-office-building</v-icon> -->
                            <span>CAP</span>
                        </div>
                        <div class="info-value">{{ azienda.cap || '-' }}</div>
                    </div>
                </v-col>

                <v-col cols="6" md="2">
                    <div class="info-field">
                        <div class="info-label">
                            <!-- <v-icon size="18" color="grey-darken-1">mdi-card-account-details</v-icon> -->
                            <span>Provincia</span>
                        </div>
                        <div class="info-value">{{ azienda.provincia || '-' }}</div>
                    </div>
                </v-col>
            </v-row>

            <!-- Card alternative style -->
            <!-- <v-row class="mt-4">
                <v-col cols="12" md="6">
                    <v-card variant="outlined" class="info-card">
                        <v-card-text>
                            <div class="d-flex align-center mb-2">
                                <v-icon color="primary" class="mr-2">mdi-office-building-outline</v-icon>
                                <span class="text-caption text-grey-darken-1">Ragione Sociale</span>
                            </div>
                            <div class="text-h6">{{ azienda.ragioneSociale || 'Non specificata' }}</div>
                        </v-card-text>
                    </v-card>
                </v-col>

                <v-col cols="12" md="6">
                    <v-card variant="outlined" class="info-card">
                        <v-card-text>
                            <div class="d-flex align-center mb-2">
                                <v-icon color="primary" class="mr-2">mdi-identifier</v-icon>
                                <span class="text-caption text-grey-darken-1">Partita IVA</span>
                            </div>
                            <div class="text-h6">{{ azienda.pIva || 'Non specificata' }}</div>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row> -->

        </div>

        <!-- Personalizzazione documenti PDF (solo admin/super-admin) -->
        <div class="section-container mt-4" v-if="isAdmin">
            <div class="section-header mb-4">
                <v-icon color="primary" size="20">mdi-file-pdf-box</v-icon>
                <h3 class="section-title">Personalizzazione documenti PDF</h3>
            </div>

            <template v-if="loadingPdf">
                <v-skeleton-loader type="article" />
            </template>

            <template v-else-if="!pdfConfig.personalizzabile">
                <v-alert type="info" variant="tonal" density="compact">
                    <div class="d-flex align-center justify-space-between flex-wrap gap-3">
                        <span>
                            <strong>Disponibile con il piano Pro.</strong>
                            Aggiungi il tuo logo, un colore personalizzato e testi su intestazione e
                            piè di pagina ai PDF che esporti dai rilievi.
                        </span>
                        <v-btn size="small" variant="elevated" color="primary"
                            :to="{ name: 'profilo', params: { tab: 'licenza' } }">
                            Passa a Pro
                        </v-btn>
                    </div>
                </v-alert>
            </template>

            <template v-else>
                <v-row>
                    <!-- ── Form ── -->
                    <v-col cols="12" md="7">
                        <v-row>
                            <v-col cols="12" sm="6">
                                <v-select v-model="pdfForm.template" :items="opzioniTemplate" item-title="title"
                                    item-value="value" label="Layout PDF" variant="outlined" density="compact"
                                    hide-details />
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-text-field v-model="pdfForm.coloreAccento" label="Colore principale" type="color"
                                    variant="outlined" density="compact" hide-details />
                            </v-col>
                        </v-row>

                        <v-row class="mt-1">
                            <v-col cols="12">
                                <v-file-input v-model="logoFile" label="Logo (PNG o JPG)"
                                    accept="image/png,image/jpeg" variant="outlined" density="compact"
                                    prepend-icon="mdi-image" hide-details :loading="caricandoLogo"
                                    @update:model-value="onLogoScelto" />
                                <div v-if="pdfConfig.haLogo && !logoFile" class="mt-1">
                                    <v-btn variant="text" color="error" size="x-small" :loading="rimuovendoLogo"
                                        @click="rimuoviLogo">
                                        Rimuovi logo attuale
                                    </v-btn>
                                </div>
                            </v-col>
                        </v-row>

                        <v-row class="mt-1">
                            <v-col cols="12" sm="8">
                                <v-text-field v-model="pdfForm.intestazione" label="Testo intestazione (opzionale)"
                                    variant="outlined" density="compact" hide-details maxlength="500" />
                            </v-col>
                            <v-col cols="12" sm="4">
                                <v-select v-model="pdfForm.posizioneIntestazione" :items="opzioniPosizioneIntestazione"
                                    item-title="title" item-value="value" label="Posizione" variant="outlined"
                                    density="compact" hide-details />
                            </v-col>
                        </v-row>

                        <v-row class="mt-2">
                            <v-col cols="12" sm="8">
                                <v-text-field v-model="pdfForm.piePagina" label="Testo piè di pagina (opzionale)"
                                    variant="outlined" density="compact" hide-details maxlength="500" />
                            </v-col>
                            <v-col cols="12" sm="4">
                                <v-select v-model="pdfForm.posizionePiePagina" :items="opzioniLatoDestraSinistra"
                                    item-title="title" item-value="value" label="Posizione" variant="outlined"
                                    density="compact" hide-details />
                            </v-col>
                        </v-row>

                        <v-row class="mt-2" align="center">
                            <v-col cols="12" sm="6">
                                <v-checkbox v-model="pdfForm.mostraNumeroPagine" label="Mostra numero di pagine"
                                    density="compact" hide-details />
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-select v-model="pdfForm.posizioneNumeroPagine" :items="opzioniLatoDestraSinistra"
                                    item-title="title" item-value="value" label="Posizione numero pagine"
                                    variant="outlined" density="compact" hide-details
                                    :disabled="!pdfForm.mostraNumeroPagine" />
                            </v-col>
                        </v-row>

                        <v-row class="mt-1">
                            <v-col cols="12" sm="6">
                                <v-checkbox v-model="pdfForm.misureNuovaPagina"
                                    label="Tabella misure su una nuova pagina" density="compact" hide-details />
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-checkbox v-model="pdfForm.mostraDataStampa" label="Includi data e ora di stampa"
                                    density="compact" hide-details />
                            </v-col>
                        </v-row>

                        <div class="d-flex justify-end mt-4">
                            <v-btn color="primary" variant="elevated" :loading="salvandoPdf"
                                prepend-icon="mdi-content-save" @click="salvaPdfConfig">
                                Salva personalizzazione
                            </v-btn>
                        </div>
                    </v-col>

                    <!-- ── Anteprima live ── -->
                    <v-col cols="12" md="5">
                        <div class="text-caption text-medium-emphasis mb-2">
                            Anteprima indicativa (non è il PDF reale, serve solo a farsi un'idea)
                        </div>
                        <div class="pdf-preview" :style="{ '--pdf-accent': pdfForm.coloreAccento || '#1E3A5F' }">
                            <div class="pdf-preview-header"
                                :class="pdfForm.posizioneIntestazione === 'top_right' ? 'pdf-preview-header--riga' : 'pdf-preview-header--colonna'">
                                <div class="pdf-preview-header-riga-logo">
                                    <img v-if="logoPreviewUrl" :src="logoPreviewUrl" class="pdf-preview-logo" />
                                    <span v-else class="pdf-preview-logo-placeholder">LOGO</span>
                                </div>
                                <div v-if="pdfForm.intestazione" class="pdf-preview-intestazione">
                                    {{ pdfForm.intestazione }}
                                </div>
                            </div>
                            <div v-if="pdfForm.mostraDataStampa" class="pdf-preview-data-stampa">
                                Stampato il 25/09/2026 10:30
                            </div>

                            <div class="pdf-preview-title">Rilievo Misure — Commessa N. 2026/014</div>
                            <div class="pdf-preview-subtitle">
                                Mario Rossi | Via Roma 10, Milano | Data: 24/09/2026
                            </div>

                            <template v-if="pdfForm.template !== 'compatto'">
                                <div class="pdf-preview-sezione">Dati Cliente</div>
                                <div class="pdf-preview-campo">
                                    <span>Telefono</span><span>+39 333 1234567</span>
                                </div>
                                <div class="pdf-preview-campo" v-if="pdfForm.template === 'dettagliato'">
                                    <span>Email</span><span>mario.rossi@email.it</span>
                                </div>
                            </template>

                            <div class="pdf-preview-sezione d-flex align-center gap-2">
                                Misure
                                <v-chip v-if="pdfForm.misureNuovaPagina" size="x-small" variant="tonal" color="primary">
                                    su nuova pagina
                                </v-chip>
                            </div>
                            <table class="pdf-preview-table">
                                <thead>
                                    <tr>
                                        <th>Rif</th>
                                        <th>L</th>
                                        <th>H</th>
                                        <th>Note</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>01</td>
                                        <td>1200</td>
                                        <td>1450</td>
                                        <td>Salone</td>
                                    </tr>
                                    <tr>
                                        <td>02</td>
                                        <td>900</td>
                                        <td>1450</td>
                                        <td>Cucina</td>
                                    </tr>
                                    <tr>
                                        <td>03</td>
                                        <td>1500</td>
                                        <td>2100</td>
                                        <td>Portafinestra</td>
                                    </tr>
                                </tbody>
                            </table>

                            <div class="pdf-preview-footer">
                                <span v-if="pdfForm.posizionePiePagina !== 'destra'">
                                    {{ pdfForm.piePagina || 'Generato con Rilievi Misure' }}
                                </span>
                                <span v-if="pdfForm.mostraNumeroPagine && pdfForm.posizioneNumeroPagine !== 'destra'">
                                    1 / 1
                                </span>
                                <v-spacer />
                                <span v-if="pdfForm.mostraNumeroPagine && pdfForm.posizioneNumeroPagine === 'destra'">
                                    1 / 1
                                </span>
                                <span v-if="pdfForm.posizionePiePagina === 'destra'">
                                    {{ pdfForm.piePagina || 'Generato con Rilievi Misure' }}
                                </span>
                            </div>
                        </div>
                    </v-col>
                </v-row>

                <v-snackbar v-model="snackbarPdf.show" :color="snackbarPdf.color" location="bottom right"
                    :timeout="3000">
                    {{ snackbarPdf.text }}
                </v-snackbar>
            </template>
        </div>

    </v-card-text>
</template>

<script>
import { mapGetters } from 'vuex'
import {
    get_pdf_config, aggiorna_pdf_config, carica_logo_pdf, rimuovi_logo_pdf, get_logo_pdf
} from '@/api/api.profilo.js'

export default {
    name: "TabAzienda",

    props: {
        azienda: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            loadingPdf: false,
            salvandoPdf: false,
            caricandoLogo: false,
            rimuovendoLogo: false,
            logoFile: null,
            logoPreviewUrl: null,
            pdfConfig: {
                personalizzabile: false,
                template: 'standard',
                coloreAccento: null,
                intestazione: '',
                piePagina: '',
                haLogo: false,
                posizioneIntestazione: 'sotto_logo',
                posizionePiePagina: 'sinistra',
                mostraNumeroPagine: true,
                posizioneNumeroPagine: 'destra',
                misureNuovaPagina: false,
                mostraDataStampa: false
            },
            pdfForm: {
                template: 'standard',
                coloreAccento: '#1E3A5F',
                intestazione: '',
                piePagina: '',
                posizioneIntestazione: 'sotto_logo',
                posizionePiePagina: 'sinistra',
                mostraNumeroPagine: true,
                posizioneNumeroPagine: 'destra',
                misureNuovaPagina: false,
                mostraDataStampa: false
            },
            opzioniTemplate: [
                { title: 'Standard', value: 'standard' },
                { title: 'Compatto', value: 'compatto' },
                { title: 'Dettagliato', value: 'dettagliato' }
            ],
            opzioniPosizioneIntestazione: [
                { title: 'Sotto al logo', value: 'sotto_logo' },
                { title: 'In alto a destra', value: 'top_right' }
            ],
            opzioniLatoDestraSinistra: [
                { title: 'Sinistra', value: 'sinistra' },
                { title: 'Destra', value: 'destra' }
            ],
            snackbarPdf: { show: false, text: '', color: 'success' }
        }
    },

    computed: {
        ...mapGetters('user', { role: 'getRole' }),
        isAdmin() {
            return this.role === 1 || this.role === 3
        }
    },

    mounted() {
        if (this.isAdmin) this.caricaPdfConfig()
    },

    beforeUnmount() {
        if (this.logoPreviewUrl) URL.revokeObjectURL(this.logoPreviewUrl)
    },

    methods: {
        async caricaPdfConfig() {
            this.loadingPdf = true
            try {
                const res = await get_pdf_config()
                this.pdfConfig = res.data
                this.pdfForm = {
                    template: res.data.template || 'standard',
                    coloreAccento: res.data.coloreAccento || '#1E3A5F',
                    intestazione: res.data.intestazione || '',
                    piePagina: res.data.piePagina || '',
                    posizioneIntestazione: res.data.posizioneIntestazione || 'sotto_logo',
                    posizionePiePagina: res.data.posizionePiePagina || 'sinistra',
                    mostraNumeroPagine: res.data.mostraNumeroPagine !== undefined ? res.data.mostraNumeroPagine : true,
                    posizioneNumeroPagine: res.data.posizioneNumeroPagine || 'destra',
                    misureNuovaPagina: !!res.data.misureNuovaPagina,
                    mostraDataStampa: !!res.data.mostraDataStampa
                }

                if (res.data.haLogo) {
                    await this.caricaAnteprimaLogo()
                } else {
                    this.impostaLogoPreview(null)
                }
            } catch (e) {
                console.error('Errore caricamento configurazione PDF:', e)
            } finally {
                this.loadingPdf = false
            }
        },

        // Recupera il logo già salvato lato server per mostrarlo nell'anteprima
        // (richiede una fetch autenticata: un <img src> diretto non passerebbe il token)
        async caricaAnteprimaLogo() {
            try {
                const res = await get_logo_pdf()
                this.impostaLogoPreview(URL.createObjectURL(res.data))
            } catch (e) {
                console.error('Errore caricamento anteprima logo:', e)
            }
        },

        // Sostituisce l'URL di anteprima del logo, rilasciando quello precedente
        // per non accumulare object URL inutilizzati
        impostaLogoPreview(url) {
            if (this.logoPreviewUrl) URL.revokeObjectURL(this.logoPreviewUrl)
            this.logoPreviewUrl = url
        },

        // Mostra subito un'anteprima del file appena scelto (prima ancora che sia
        // stato caricato sul server), poi avvia il caricamento vero e proprio
        onLogoScelto(file) {
            if (!file) return
            this.impostaLogoPreview(URL.createObjectURL(file))
            this.caricaLogo(file)
        },

        async salvaPdfConfig() {
            this.salvandoPdf = true
            try {
                await aggiorna_pdf_config(this.pdfForm)
                this.notificaPdf('Personalizzazione salvata con successo.')
                await this.caricaPdfConfig()
            } catch (e) {
                console.error('Errore salvataggio configurazione PDF:', e)
                this.notificaPdf('Errore durante il salvataggio.', 'error')
            } finally {
                this.salvandoPdf = false
            }
        },

        async caricaLogo(file) {
            if (!file) return
            this.caricandoLogo = true
            try {
                await carica_logo_pdf(file)
                this.notificaPdf('Logo caricato con successo.')
                await this.caricaPdfConfig()
            } catch (e) {
                console.error('Errore caricamento logo:', e)
                this.notificaPdf('Errore durante il caricamento del logo.', 'error')
            } finally {
                this.logoFile = null
                this.caricandoLogo = false
            }
        },

        async rimuoviLogo() {
            this.rimuovendoLogo = true
            try {
                await rimuovi_logo_pdf()
                this.notificaPdf('Logo rimosso.')
                await this.caricaPdfConfig()
            } catch (e) {
                console.error('Errore rimozione logo:', e)
                this.notificaPdf('Errore durante la rimozione del logo.', 'error')
            } finally {
                this.rimuovendoLogo = false
            }
        },

        notificaPdf(text, color = 'success') {
            this.snackbarPdf = { show: true, text, color }
        }
    }
}
</script>

<style scoped>
.section-container {
    background-color: #fafafa;
    border-radius: 8px;
    padding: 20px;
}

.section-header {
    display: flex;
    align-items: center;
    gap: 8px;
}

.section-title {
    font-size: 16px;
    font-weight: 600;
    color: #333;
}

.info-field {
    background-color: white;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    padding: 16px;
}

.info-label {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 12px;
    color: #757575;
    margin-bottom: 8px;
    text-transform: uppercase;
    font-weight: 500;
}

.info-value {
    font-size: 16px;
    font-weight: 600;
    color: #333;
}

.info-card {
    height: 100%;
    transition: all 0.2s;
}

.info-card:hover {
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

/* Anteprima PDF (mock HTML/CSS, non è il documento reale) */
.pdf-preview {
    --pdf-accent: #1E3A5F;
    aspect-ratio: 1.414 / 1;
    background: white;
    border: 1px solid #ddd;
    border-radius: 6px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, .08);
    padding: 14px 16px;
    font-family: Verdana, Geneva, sans-serif;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

.pdf-preview-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    min-height: 26px;
    margin-bottom: 8px;
}

.pdf-preview-logo {
    max-height: 26px;
    max-width: 110px;
    object-fit: contain;
}

.pdf-preview-logo-placeholder {
    font-size: 9px;
    color: #bbb;
    border: 1px dashed #ccc;
    border-radius: 3px;
    padding: 4px 8px;
}

.pdf-preview-intestazione {
    font-size: 8px;
    color: #888;
}

.pdf-preview-header--riga .pdf-preview-intestazione {
    text-align: right;
}

.pdf-preview-header--colonna .pdf-preview-intestazione {
    margin-top: 4px;
}

.pdf-preview-title {
    font-size: 15px;
    font-weight: 700;
    color: var(--pdf-accent);
    line-height: 1.2;
}

.pdf-preview-subtitle {
    font-size: 9px;
    color: #555;
    margin-bottom: 10px;
}

.pdf-preview-sezione {
    font-size: 10px;
    font-weight: 700;
    color: var(--pdf-accent);
    margin: 6px 0 4px;
}

.pdf-preview-campo {
    display: flex;
    gap: 8px;
    font-size: 9px;
    margin-bottom: 2px;
}

.pdf-preview-campo span:first-child {
    font-weight: 700;
    width: 64px;
    flex-shrink: 0;
}

.pdf-preview-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 9px;
}

.pdf-preview-table th {
    background: var(--pdf-accent);
    color: white;
    font-weight: 700;
    text-align: left;
    padding: 4px 6px;
}

.pdf-preview-table td {
    padding: 3px 6px;
    border-bottom: 1px solid #eee;
}

.pdf-preview-table tbody tr:nth-child(even) {
    background: #f2f4f7;
}

.pdf-preview-footer {
    margin-top: auto;
    padding-top: 8px;
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 7px;
    color: #999;
}

.pdf-preview-footer .v-spacer {
    flex-grow: 1;
}

/* Intestazione: sotto al logo (impilata) oppure logo + testo sulla stessa riga */
.pdf-preview-header--colonna {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
}

.pdf-preview-header--riga {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.pdf-preview-header-riga-logo {
    display: flex;
}

.pdf-preview-data-stampa {
    font-size: 7px;
    color: #999;
    text-align: right;
    margin-bottom: 4px;
}
</style>